import ClientServicesHours7to6 from './clientServicesHours7to6';

export default ClientServicesHours7to6;
